// Utility functions to format table data

function col_to_row_format(table) {
    // Convert data from a column format to a row format.
    // Input is in column format, eg. as generated by pandas.to_dict(data, orient='list'):
    //    Dictionary of columns: //    {column_name: [col_values]}
    // The output is in row format, as used by coreui-tables:
    //    Array of row records: [{column_name1: value, column_name2: value, ...}]

    let column_names = Object.keys(table)
    let num_columns = column_names.length
    if (num_columns == 0) {
        return []
    }
    let num_rows = table[column_names[0]].length
    let new_table = []
    for (let r=0; r<num_rows; r++) {
        let row = {}
        for (let c=0; c<num_columns; c++) {
            row[column_names[c]] = table[column_names[c]][r]
        }
        new_table.push(row)
    }
    return new_table
}

// Format to format numbers without fractional digits and in de-CH format.
let number_format_frch_rounded = n => n.toLocaleString("de-CH", {maximumFractionDigits: 0}) 

// Format to format numbers two fractional digits and in de-CH format.
let number_format_frch_two_decimals = n => n.toLocaleString("de-CH", {maximumFractionDigits: 2, minimumFractionDigits: 2}) 

// Format date in fr-CH format.
let date_format_frch_short = d => new Date(d).toLocaleDateString('fr-CH').replace('Invalid Date', '---')

exports.col_to_row_format = col_to_row_format
exports.number_format_frch_rounded = number_format_frch_rounded
exports.number_format_frch_two_decimals = number_format_frch_two_decimals
exports.date_format_frch_short = date_format_frch_short